import { AxiosError } from 'axios';

import { ZEE_FINANCIAL_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { ZeeFinancial, ZeeOtherFinancial } from '@/types/zee.type';

export type GetZeeFinancialApiResponse = {
  zee_financial: ZeeFinancial;
  zee_other_financial: ZeeOtherFinancial;
};

export const getZeeFinancial = async (): Promise<
  ApiResponse<GetZeeFinancialApiResponse>
> => {
  try {
    const response = await apiManager.get(ZEE_FINANCIAL_API_URL, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
